import { BasketballTeamGame } from '@hefe/models';
import {
  BasketballGameAddCarpoolRequest,
  BasketballGamesSlice,
  ModalsSlice,
} from '@hefe/store';
import { t } from '@hefe/i18n';
import React from 'react';
import { useAppDispatch } from '../../../../store/store';
import CustomForm from '../../../core/components/form/custom-form';

interface GameTeamCarpoolFormProps {
  teamDetails: BasketballTeamGame;
}

export default function GameTeamCarpoolForm(props: GameTeamCarpoolFormProps) {
  const { teamDetails } = props;
  const dispatch = useAppDispatch();

  const userCoach = teamDetails.user_coaches
    ? teamDetails.user_coaches.length > 0
      ? teamDetails.user_coaches[0]
      : null
    : null;
  const userPlayer = teamDetails.user_players
    ? teamDetails.user_players.length > 0
      ? teamDetails.user_players[0]
      : null
    : null;

  const user = userCoach ? userCoach : userPlayer;

  if (!user) return null;

  const onSubmit = (values: any, resetForm: any) => {
    const setModalLoading = ModalsSlice.modalsActions.setModalLoading;
    const payload: BasketballGameAddCarpoolRequest = {
      team_id: teamDetails.team_id,
      note: values.note,
      number_of_seats: values.number_of_seats,
      user_id: user.id,
    };
    dispatch(setModalLoading(true));
    dispatch(
      BasketballGamesSlice.addCarpoolToGame({
        gameId: teamDetails.game_id,
        payload: payload,
      })
    )
      .unwrap()
      .then(() => dispatch(ModalsSlice.modalsActions.closeModal()))
      .catch(() => null)
      .finally(() => dispatch(setModalLoading(false)));
  };

  return (
    <CustomForm
      formId="event-team-carpool"
      fields={[
        {
          label: t('seats'),
          name: 'number_of_seats',
          type: 'number',
          rules: [
            {
              min: 1,
              required: true,
              message: t('form_errors.number'),
            },
          ],
        },
        {
          label: t('note'),
          name: 'note',
          type: 'text',
          rules: [],
        },
      ]}
      onSubmit={onSubmit}
    />
  );
}
